interface ButtonConfig {
    key: string;
    label: string;
    icon: string;
    altIcons?: Record<string, string>;
}

export default function renderButtons(buttons: ButtonConfig[], btnClass?: string): string {
    let _html = '';

    for(var i = buttons.length; i--;) {
        let x = buttons[i];
        if(x.key === 'font-size'){
            _html += `
            <div class="cya11y-adjust-font ${ btnClass || '' }" role="group" aria-labelledby="font-size-control">
                <div class="cya11y-label" id="font-size-control">
                    ${ x.icon }
                    <span class="cya11y-translate">${ x.label }</span>
                </div>
                <div class="cya11y-font-controls">
                    <button class="cya11y-minus" type="button" aria-label="Decrease font size" aria-describedby="font-size-control">
                        <svg viewBox="0 0 24 24" width="38" height="38" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <rect x="5" y="11" width="14" height="2" rx="1" fill="white"/>
                        </svg>
                        <span class="cya11y-sr-only">Decrease font size</span>
                    </button>
                    <span class="cya11y-amount" aria-live="polite" aria-atomic="true">100%</span>
                    <button class="cya11y-plus" type="button" aria-label="Increase font size" aria-describedby="font-size-control">
                        <svg viewBox="0 0 24 24" width="38" height="38" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <rect x="11" y="5" width="2" height="14" rx="1" fill="white"/>
                            <rect x="5" y="11" width="14" height="2" rx="1" fill="white"/>
                        </svg>
                        <span class="cya11y-sr-only">Increase font size</span>
                    </button>
                </div>
            </div>
            `;
        }else if(x.key === 'text-align' && x.altIcons){
            _html += `<button class="cya11y-btn cya11y-text-align ${ btnClass || '' }" type="button" data-key="${ x.key }" data-state="off" title="${ x.label }" aria-pressed="false" aria-describedby="${ x.key }-description">`
                + `<span class="cya11y-text-align-icon" data-icon="left">${ x.altIcons.left }</span>`
                + `<span class="cya11y-text-align-icon" data-icon="right">${ x.altIcons.right }</span>`
                + `<span class="cya11y-text-align-icon" data-icon="center">${ x.altIcons.center }</span>`
                + `<span class="cya11y-translate">${ x.label }</span>`
                + `<span class="cya11y-sr-only" id="${ x.key }-description">Cycle text alignment: left, right, center</span>`
                + `<span class="cya11y-text-align-progress" aria-hidden="true">`
                + `<span class="cya11y-text-align-segment" data-pos="left"></span>`
                + `<span class="cya11y-text-align-segment" data-pos="center"></span>`
                + `<span class="cya11y-text-align-segment" data-pos="right"></span>`
                + `</span>`
                + `</button>`;
        }else{
            _html += `<button class="cya11y-btn ${ btnClass || '' }" type="button" data-key="${ x.key }" title="${ x.label }" aria-pressed="false" aria-describedby="${ x.key }-description">${ x.icon }<span class="cya11y-translate">${ x.label }</span><span class="cya11y-sr-only" id="${ x.key }-description">Toggle ${ x.label.toLowerCase() } setting</span></button>`;
        }
    }

    return _html;
}
